module.exports = __webpack_public_path__ + "img/daizy_traffic.220d87ce.jpg";